module.exports = __webpack_public_path__ + "static/media/bold.92dc75b8.svg";